import React, { useEffect, useState } from "react";
import { TenantStatusName } from "@packsize/identity-api-sdk";
import { useSearchParams } from "react-router-dom";

import { useTenantStatus } from "@/hooks/use-tenant-status";

import {
	LIVE_ENVIRONMENT_ANIMATION_DURATION,
	LiveEnvironmentWrapperTemplate,
} from "./live-environment-wrapper.template";

export const LiveEnvironmentWrapper: React.FC = () => {
	const [isAnimateIn, setIsAnimateIn] = useState(true);
	const [isVisible, setIsVisible] = useState(false);
	const [isSupportUser, setIsSupportUser] = useState(false);
	const tenantStatus = useTenantStatus();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		setIsSupportUser(searchParams.get("supportUser") === "true");
	}, []);

	useEffect(() => {
		if (!isSupportUser) return;

		setIsVisible(tenantStatus === TenantStatusName.Operating);
	}, [tenantStatus, isSupportUser]);

	const handleClose = () => {
		setIsSupportUser(false);
		setIsAnimateIn(false);
		setTimeout(() => setIsVisible(false), LIVE_ENVIRONMENT_ANIMATION_DURATION - 50);
		// set this just under the animation duration so we don't flash the banner at the enc
	};

	if (!isVisible) {
		return null;
	}

	return <LiveEnvironmentWrapperTemplate isAnimateIn={isAnimateIn} onClose={handleClose} />;
};
